import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { TranslateModule } from '@ngx-translate/core';
import { CancelOpenBankingPopinComponent } from '@shared/components/cancel-open-banking-popin/cancel-open-banking-popin.component';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { TrackerService } from '@shared/services/tracker.service';

@Component({
  selector: 'app-none-accounts-found',
  templateUrl: './none-accounts-found.component.html',
  standalone: true,
  imports: [TranslateModule, CancelOpenBankingPopinComponent],
})
export class NoneAccountsFoundComponent implements OnInit {
  isPopinOpen = false;

  constructor(
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'NONE_ACCOUNTS' });
  }

  openPopin() {
    this.tracker.trackClick({
      click: frenchi18n.come_back_to_classic_form,
      taggingPage: 'NONE_ACCOUNTS',
    });

    this.isPopinOpen = true;
  }

  closePopin() {
    this.isPopinOpen = false;
  }

  connectToOtherBank() {
    this.tracker.trackClick({
      click: frenchi18n.connect_to_another_bank,
      taggingPage: 'NONE_ACCOUNTS',
    });

    this.processEventService.push(ProcessEventFactory.SpawnGoBackToBankChoiceEvent());
  }
}
